import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <Box
        sx={{
          "& ol li": {
            fontSize: "1.188rem",
          },
        }}
      >
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={8} md={8}>
            <a className={classes.anchor} id="start"></a>
            <h3 className={classes.title}>
              Can you get GA4 Custom Dimensions and metrics into Looker Studio?
            </h3>
            <p>
              The answer is yes. Some time from what I can gather, in midway
              2022, Google allowed you to use your GA4 custom dimensions in
              Looker Studio reports.
              <br />
              <br />
              But you wont see them in your data list in Looker Studio
              immediately.
              <br />
              <br />
              <strong>
                The key point is to reconnect your data source after creating
                the custom dimension in GA4!
              </strong>{" "}
              <br />
              <br />
              Looker Studio/GA4 does not do this automatically! Once you have
              created your custom dimension and data is coming through in GA4,
              you can go to Looker studio, refresh your data source and a new
              dimension will be added.
            </p>
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title}>
              Full Process to get GA4 Custom Dimension data in Looker Studio
            </h3>
            <h4 className={classes.title}>
              1. Create Parameter(s) (ie what will be the custom dimension) for
              your event
            </h4>
            <p>We use GTM for this. You should use GTM too 😀</p>
          </GridItem>

          <div
            style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}
          >
            <GridItem xs={12} sm={12} md={12}>
              <img
                src="/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-4.png"
                alt="..."
                className={imgClasses}
              />

              <p>
                <br></br>
                <i>
                  Create your event parameters attached to the event you create{" "}
                </i>
              </p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
            <h4 className={classes.title}>2. Create custom dimension in GA4</h4>
            <p>Follow these steps below:</p>
          </GridItem>

          <div
            style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}
          >
            <GridItem xs={12} sm={12} md={12}>
              <img
                src="/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-5.png"
                alt="..."
                className={imgClasses}
              />

              <p>
                <br></br>
                <i>2.1 Go to Admin {">"} Custom definitions in GA4 </i>
              </p>
            </GridItem>
          </div>
          <div
            style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}
          >
            <GridItem xs={12} sm={12} md={12}>
              <img
                src="/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-1.png"
                alt="..."
                className={imgClasses}
              />

              <p>
                <br></br>
                <i>2.2 Create a new custom dimension</i>
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <img
                src="/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-2.png"
                alt="..."
                className={imgClasses}
              />

              <p>
                <br></br>
                <i>
                  2.3 Populate the event parameter with the one you created - it
                  will appear in the dropdown. In this example we are using the
                  parameter we created in step 1 called ad_element.
                  <br />
                  <br />
                  <strong>
                    We can now use this dimension in GA4 explorations AND Looker
                    Studio!
                  </strong>
                </i>
              </p>
            </GridItem>
          </div>
          <GridItem xs={12} sm={8} md={8}>
            <h4 className={classes.title}>
              3. Go to Looker Studio and reconnect your GA4 data source
            </h4>
          </GridItem>

          <div
            style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}
          >
            <GridItem xs={12} sm={12} md={12}>
              <img
                src="/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-5.png"
                alt="..."
                className={imgClasses}
              />

              <p>
                <br></br>
                <i>
                  You will <strong>immediately</strong> see the new custom
                  dimension available to be added{" "}
                </i>
              </p>
            </GridItem>
          </div>
          <GridItem xs={12} sm={8} md={8}>
            <p>
              And.. you are done! 😀
              <br />
              <br />
              Let us know how it goes and if you have any questions - always
              happy to help out at info@trbalism.com.au
            </p>
          </GridItem>
        </GridContainer>
      </Box>
    </div>
  );
}
